import BasePopup from '../Base/BasePopup';
export default BasePopup;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_rc-tree-select@2.6.1@rc-tree-select/es/Popup/MultiplePopup.js
// module id = null
// module chunks = 